export default {
    emailBlank: 'Please enter email',
    invalidEmail: 'Please enter valid email',
    userNameBlank: 'Please enter username',
    passwordBlank: 'Please enter password',
    userNotExists:"User name or password is incorrect",
};
